import React, { useState, useRef, useEffect } from 'react';
import { useRestaurant } from '../contexts/RestaurantContext';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronDown, Building2, Check } from 'lucide-react';

export default function RestaurantSwitcher({ collapsed }) {
  const { t } = useTranslation();
  const { currentRestaurant, restaurants, switchRestaurant, isOrgAdmin } = useRestaurant();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  if (!isOrgAdmin || restaurants.length <= 1) return null;

  if (collapsed) {
    return (
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex justify-center p-2 rounded-lg text-white/70 hover:bg-white/10 transition-colors"
        title={currentRestaurant?.name}
      >
        <Building2 className="w-4 h-4" />
      </button>
    );
  }

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-white/80 hover:bg-white/10 transition-colors text-sm"
      >
        <Building2 className="w-5 h-5 text-white/50 flex-shrink-0" />
        <span className="truncate flex-1 text-left font-medium">
          {currentRestaurant?.name || t('orgPanel.selectRestaurant')}
        </span>
        <ChevronDown className={`w-3.5 h-3.5 text-white/40 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute left-0 right-0 top-full mt-1 bg-white rounded-lg shadow-lg border border-slate-200 py-1 z-50">
          {restaurants.map((r) => (
            <button
              key={r.id}
              onClick={() => { switchRestaurant(r.id); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-slate-50 transition-colors ${
                r.id === currentRestaurant?.id ? 'text-emerald-700 font-medium' : 'text-slate-700'
              }`}
            >
              <span className="truncate flex-1 text-left">{r.name}</span>
              {r.id === currentRestaurant?.id && <Check className="w-4 h-4 text-emerald-600" />}
            </button>
          ))}
          <div className="border-t border-slate-100 mt-1 pt-1">
            <button
              onClick={() => { navigate('/org-panel'); setOpen(false); }}
              className="w-full flex items-center gap-2 px-3 py-2 text-sm text-slate-500 hover:bg-slate-50 hover:text-slate-700 transition-colors"
            >
              <Building2 className="w-4 h-4" />
              <span>{t('orgPanel.title')}</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
